"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMS_COLLECTION = exports.CMS_VERSION = exports.CMS_API = void 0;
exports.CMS_API = '/insync/cms-api';
exports.CMS_VERSION = 'v3';
exports.CMS_COLLECTION = {
    CURRICULA: 'curricula',
};
